// @ts-nocheck

import { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Box, Text } from '@zillow/constellation-10';
import { LoadingHeading } from '@zg-rentals/loading-components';

import SpinnerContainer from '../../components/SpinnerContainer';

import { connectedCardRecipe, headingWrapperRecipe } from './styles';

const ConnectedModuleCard = ({
  children,
  className = '',
  css: cssProp,
  ctaComponent,
  ctaFontColor,
  ctaFontType,
  enableHover: pEnableHover,
  hideBorderOnMobile = false,
  includeBorderTop = false,
  isLoading,
  justifyHeadingContent,
  leftComponent,
  spinnerHeight: height,

  title,
  titleGrow,
}) => {
  const [enableHover, setEnableHover] = useState(false);

  const renderSpinner = () => <SpinnerContainer height={height} />;

  const handleMouseOver = () => {
    if (pEnableHover) {
      setEnableHover(true);
    }
  };

  const handleMouseOut = () => {
    if (pEnableHover) {
      setEnableHover(false);
    }
  };

  return (
    <Box
      data-testid="ConnectedCard"
      className={cx('ConnectedCard', className)}
      css={connectedCardRecipe.raw({ includeBorderTop, enableHover, hideBorderOnMobile }, cssProp)}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      {(leftComponent || title || ctaComponent) && (
        <Box className="ConnectedCard-TitleWrapper" css={headingWrapperRecipe.raw({ justifyHeadingContent })}>
          {leftComponent && <div data-testid="ConnectedCard-Heading">{leftComponent}</div>}

          {title && (
            <LoadingHeading
              data-testid="ConnectedCard-Heading"
              level={2}
              isLoading={isLoading}
              loadingWidth="40%"
              css={{
                fontSize: { base: 'body', lg: 'heading-xs' },
                lineHeight: { base: 'body', lg: 'heading-xs' },
                flexGrow: titleGrow,
                marginRight: '400',
                color: enableHover ? 'text.action.hero.default' : 'text.neutral',
              }}
            >
              {title}
            </LoadingHeading>
          )}

          <Box css={{ marginBottom: { base: '400', lg: '0' } }} />

          {ctaComponent && (
            <Text
              className="ConnectedCard-CTA"
              css={{
                textStyle: ctaFontType,
                color: enableHover ? 'text.action.hero.default' : ctaFontColor,
                _hover: { color: 'text.action.hero.default' },
              }}
            >
              {ctaComponent}
            </Text>
          )}
        </Box>
      )}
      {children}
    </Box>
  );
};

ConnectedModuleCard.propTypes = {
  css: PropTypes.object,
  ctaComponent: PropTypes.node,
  ctaFontColor: PropTypes.string,
  ctaFontType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  enableHover: PropTypes.bool,
  fontType: PropTypes.string,
  hideBorderOnMobile: PropTypes.bool,
  isLoading: PropTypes.bool,
  justifyHeadingContent: PropTypes.oneOf(['flex-start', 'space-between', 'center']),
  leftComponent: PropTypes.node,
  spinnerHeight: PropTypes.string,

  title: PropTypes.string,
  titleGrow: PropTypes.number,
};

ConnectedModuleCard.defaultProps = {
  css: null,
  ctaComponent: null,
  ctaFontColor: 'text.neutral',
  ctaFontType: { base: 'body-sm', lg: 'body' },
  enableHover: false,
  hideBorderOnMobile: false,
  isLoading: false,
  justifyHeadingContent: 'flex-start',
  leftComponent: null,
  spinnerHeight: '200px',
  title: null,
  titleGrow: 1,
};

export default ConnectedModuleCard;
